export default __webpack_public_path__ + "static/assets/NunitoBold.1280f751.woff";